import {axiosService} from "../axios.service";
import {urls} from "../../constants";

const periodsService = {
    getAll: () => axiosService.get(urls.settings.periods).then(value => value.data),
    createPeriod: (data) => axiosService.post(urls.settings.periods, data).then((value) => value.data),
    updateById: (id, data) => axiosService.patch(`${urls.settings.periods }/${id}`, data).then((value) => value.data),
    deleteById: (id) => axiosService.destroy(`${urls.settings.periods}/${id}`),
};

export {
    periodsService
}